import React from 'react'
import { Link } from 'gatsby'

const BlogCard = ({ post }) => (
  <div className="max-w-sm rounded overflow-hidden card">
    <Link to={post.fields.slug}>
      {post.frontmatter.thumbnail && (
        <img
          className="w-full"
          src={post.frontmatter.thumbnail}
          alt={post.frontmatter.title + '- Featured Shot'}
        />
      )}
      <div className="px-3 py-2">
        <div className="font-bold text-lg mb-2">{post.frontmatter.title}</div>
        <p className="text-gray-700 text-base">
          {post.frontmatter.metaDescription}
        </p>
      </div>
    </Link>
    <div className="px-6 py-4">
      {post.frontmatter.tags && post.frontmatter.tags.map(tag => (
        <Link to={`/tags/${tag}`}>
          <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">
          #{tag}
        </span>
        </Link>
      ))}
    </div>
  </div>
)

export default BlogCard
